import getActivationTemplateService from '~/src/pages/auth/activation/styles/GetActivationTemplateService'
import StylesActivationServiceInterface from '~/src/pages/auth/activation/styles/StylesActivationServiceInterface'
import { useLayout } from '~/src/hooks/layout/useLayout'
import { useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import useGetPageStyle from '~/src/hooks/layout/useGetPageStyle'
import { useEoValue } from '~/src/hooks/useEoState'
import { LAYOUT_STATE } from '~/src/stores/layout'

const useGetActivationTemplate = (): StylesActivationServiceInterface => {
  const muiTheme = useCustomMuiTheme()
  const pageStyle = useGetPageStyle('activation')
  const layout = useEoValue(LAYOUT_STATE)

  useLayout('activation')

  return getActivationTemplateService(pageStyle, muiTheme, layout)
}

export default useGetActivationTemplate
